
export class Baseproperties{
    gatewayBaseURL:string=''
    isServerDeployment=true;
    constructor(){
       if(location.hostname=='localhost'){
        this.gatewayBaseURL= 'http://localhost:8090';
       }else{
        this.gatewayBaseURL= location.origin
       }
    }
}